<template>
  <v-dialog
    :model-value="show"
    :width="width"
    :persistent="persistent"
    class="dialogClass"
    @update:model-value="$emit('update:show', $event)"
  >
    <v-card class="pa-6" style="background-color: #ffffff; border: 1px solid #e8e8e8; border-radius: 12px">
      <!-- Header with title and close button -->
      <div v-if="showHeader || title" class="d-flex justify-space-between align-start mb-4">
        <div
          v-if="title"
          :style="{
            ...titleStyle,
            fontFamily: 'Space Grotesk, sans-serif',
            fontWeight: '600',
            color: '#0D0D0D',
            fontSize: '24px'
          }"
        >
          {{ title }}
        </div>
        <div v-else></div>
        <v-icon v-if="showHeader" size="24" style="color: #b0b0b0; cursor: pointer" @click="handleClose">
          mdi-close
        </v-icon>
      </div>

      <!-- Content area -->
      <div class="mb-6" :style="{ textAlign: contentAlign }">
        <!-- Main content slot -->
        <div v-if="$slots.content" class="mb-4">
          <slot name="content" />
        </div>

        <!-- Message text -->
        <div
          v-if="message"
          class="mb-4"
          :style="{
            ...messageStyle,
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '1.5'
          }"
        >
          {{ message }}
        </div>

        <!-- Default slot for additional content -->
        <div v-if="$slots.default">
          <slot />
        </div>
      </div>

      <!-- Actions section -->
      <div v-if="showActions" class="d-flex justify-start" style="gap: 12px">
        <!-- Cancel button -->
        <UiButton
          v-if="cancelText"
          :variant="cancelVariant"
          size="large"
          :style="{
            cursor: 'pointer !important'
          }"
          @click="handleCancel"
        >
          {{ cancelText }}
        </UiButton>

        <!-- Confirm/Primary action button -->
        <UiButton
          v-if="confirmText"
          :variant="confirmVariant"
          size="large"
          :style="{
            backgroundColor: confirmColor,
            color: 'black !important',
            cursor: 'pointer !important'
          }"
          :disabled="confirmDisabled"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </UiButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import UiButton from '../ui/Button.vue';

export default {
  name: 'GenericModal',

  components: {
    UiButton
  },

  emits: ['update:show', 'confirm', 'cancel', 'close'],

  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: 800
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
    contentAlign: {
      type: String,
      default: 'left'
    },
    actionAlignment: {
      type: String,
      default: 'justify-center'
    },
    // Button props
    confirmText: {
      type: String,
      default: ''
    },
    confirmVariant: {
      type: String,
      default: 'flat'
    },
    confirmColor: {
      type: String,
      default: 'primary'
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: ''
    },
    cancelVariant: {
      type: String,
      default: 'dark-outline'
    },
    cancelColor: {
      type: String,
      default: '#333'
    },
    // Custom styling props
    titleStyle: {
      type: Object,
      default: () => ({
        fontWeight: '800',
        fontSize: '36px'
      })
    },
    messageStyle: {
      type: Object,
      default: () => ({
        letterSpacing: '-0.2px',
        lineHeight: '1.5'
      })
    }
  },

  methods: {
    handleClose() {
      this.$emit('update:show', false);
      this.$emit('close');
    },

    handleConfirm() {
      this.$emit('confirm');
    },

    handleCancel() {
      this.$emit('cancel');
      this.$emit('update:show', false);
    }
  }
};
</script>
